var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable } from "mobx";
import { TypeExtends } from "sb-js-extends";
TypeExtends();
/**
 * NextRacesEvent model for visualization of Next Races block
 *
 * @typedef NextRacesEvent
 * @type {Object}
 * @property {id} Unique identifier
 * @property {row} Array of NextRacesLine
 * @property {title}  Header text of next races
 * @property {hasLiveStream} Flag for showing livesteaming icon
 * @property {url} Url path to event view
 * @property {handler} Function for navigation to event view
 */
var NextRacesEvent = /** @class */ (function () {
    function NextRacesEvent(source) {
        this.id = source.id;
        this.rows = source.rows;
        this.url = source.url;
        this.hasLiveStream = source.hasLiveStream;
        this.title = source.date.formatDate("HH:mm") + " " + source.leagueName;
        this.handler = source.handler;
    }
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], NextRacesEvent.prototype, "rows", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], NextRacesEvent.prototype, "hasLiveStream", void 0);
    return NextRacesEvent;
}());
export { NextRacesEvent };
//# sourceMappingURL=NextRaces.js.map